import React from "react";

export const AuditorControllerHomeScreen = (props) => {
  return (
    <div className="row w-100 h-100 o-hide auditor-home">
      <div className="col f-rest h-100 o-hide bgWhite">{props.children}</div>
    </div>
  );
};
